import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class LoginRouteGuard  {
  constructor(public router: Router) {}

  canActivate() {
    //    var Activate = this.WbidSwaService.isLoggedIn();
    //    if(Activate){
    //      return this.WbidSwaService.isLoggedIn();
    //    }
    //    else{
    //      this.router.navigate(['/login']);
    //    }
    // }
    sessionStorage.removeItem('activePage');
    const subscriptionReturnPage = localStorage.getItem(
      'subscriptionReturnPage'
    );
    if (subscriptionReturnPage) {
      localStorage.removeItem('subscriptionReturnPage');
      sessionStorage.setItem('activePage', subscriptionReturnPage);
      const url = window.location.href;
      const queryStringValue = url.split('?')[1].split('=')[1];
      localStorage.setItem('paymentReturnValue', queryStringValue);
      this.router.navigate(['/' + subscriptionReturnPage]);
      return false;
    }
    return true;
  }
}

@Injectable()
export class RegistrationGuard  {
  constructor(public router: Router) {}

  canActivate() {
    const temp_activePage = sessionStorage.getItem('activePage');
    const temp_empnum = sessionStorage.getItem('temp_empnum');
    if (temp_activePage === 'registration' && temp_empnum) {
      return true;
    } 
    
  this.router.navigate(['/home']);
  return false;
  }
}
@Injectable()
export class MainGuard  {
  constructor(public router: Router) {}

  canActivate() {
    // var temp_activePage = sessionStorage.getItem('activePage');
    // if (temp_activePage) {
    //   this.router.navigate(['/main']);
    //   return false;
    // }
    // else {
    //   return true;
    //   //this.router.navigate(['/login']);
    // }
    const temp_activePage = sessionStorage.getItem('activePage');
    if (temp_activePage && temp_activePage == 'home') return true;
    else {
      if (temp_activePage) this.router.navigate(['/' + temp_activePage]);
      else this.router.navigate(['/login']);
      return false;
    }
  }
}
@Injectable()
export class BidlineGuard  {
  constructor(private router: Router) {}

  canActivate() {
    const temp_activePage = sessionStorage.getItem('activePage');
    if (
      (temp_activePage && temp_activePage == 'bidline') ||
      temp_activePage == 'bidlineview'
    )
      return true;
    else {
      if (temp_activePage) this.router.navigate(['/' + temp_activePage]);
      else this.router.navigate(['/login']);
      return false;
    }
  }
}
